import React, { useState, useEffect, useMemo } from 'react';
import { useOrderContext } from '../context/OrderContext';
import { useStatusContext } from '../context/StatusContext';
import OrderCard from '../components/OrderCard';
import OrderModal from '../components/OrderModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxArchive, faPlus, faCartShopping } from '@fortawesome/free-solid-svg-icons';

const OrdersPage = () => {
  const {
    orders, archived, loading,
    fetchOrders, fetchArchived,
    archiveOrder, unarchiveOrder, deleteOrder,
  } = useOrderContext();
  const { status, getStatus } = useStatusContext();

  const [tab, setTab] = useState('current'); // current | archive
  const [modalOpen, setModalOpen] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);

  useEffect(() => {
    fetchOrders();
    fetchArchived();
    if (!status?.length) getStatus();
    // eslint-disable-next-line
  }, []);

  const list = tab === 'current' ? orders : archived;

  const supplierOrders = useMemo(() => list.filter(o => o.kind === 'supplier'), [list]);
  const clientOrders = useMemo(() => list.filter(o => o.kind === 'client'), [list]);

  const handleArchive = async (order) => {
    if (!window.confirm(`Отправить заказ № ${order.number} в архив?`)) return;
    try { await archiveOrder(order._id, order); } catch (e) { alert(e.message); }
  };
  const handleUnarchive = async (order) => {
    try { await unarchiveOrder(order._id, order); } catch (e) { alert(e.message); }
  };
  const handleDelete = async (order) => {
    if (!window.confirm(`Удалить заказ № ${order.number} навсегда?`)) return;
    try { await deleteOrder(order._id); } catch (e) { alert(e.message); }
  };

  const openCreate = () => { setEditingOrder(null); setModalOpen(true); };
  const openEdit = (o) => { setEditingOrder(o); setModalOpen(true); };

  const renderColumn = (title, list) => (
    <div className="orders-column">
      <div className="orders-column__header">
        <FontAwesomeIcon icon={faCartShopping} />
        <span>{title}</span>
        <span className="orders-column__count">{list.length}</span>
      </div>
      <div className="orders-column__body">
        {list.length === 0 && (
          <div className="orders-column__empty">Заказов нет</div>
        )}
        {list.map(o => (
          <OrderCard
            key={o._id}
            order={o}
            status={status}
            onEdit={openEdit}
            onArchive={handleArchive}
            onUnarchive={handleUnarchive}
            onDelete={handleDelete}
            isArchive={tab === 'archive'}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="crm-page">
      <div className="crm-breadcrumb">
        <span className="crm-breadcrumb__item">Рабочий стол</span>
        <span className="crm-breadcrumb__sep">›</span>
        <span className="crm-breadcrumb__item crm-breadcrumb__item--active">Заказы</span>
      </div>

      <div className="crm-page-header">
        <h1 className="crm-page-title">
          <FontAwesomeIcon icon={faCartShopping} style={{ marginRight: 10 }} />
          Заказы
        </h1>
        <div className="orders-header-actions">
          <div className="orders-tabs">
            <button
              className={`orders-tab ${tab === 'current' ? 'orders-tab--active' : ''}`}
              onClick={() => setTab('current')}
            >
              Текущие <span className="orders-tab__count">{orders.length}</span>
            </button>
            <button
              className={`orders-tab ${tab === 'archive' ? 'orders-tab--active' : ''}`}
              onClick={() => setTab('archive')}
            >
              <FontAwesomeIcon icon={faBoxArchive} /> Архив
              <span className="orders-tab__count">{archived.length}</span>
            </button>
          </div>

          {tab === 'current' && (
            <button className="price-add-btn" onClick={openCreate}>
              <FontAwesomeIcon icon={faPlus} />
              <span>Новый заказ</span>
            </button>
          )}
        </div>
      </div>

      {loading && <div className="orders-loading">Загрузка…</div>}

      {!loading && (
        <div className="orders-grid">
          {renderColumn('Заказ поставщику', supplierOrders)}
          {renderColumn('Заказ под клиента', clientOrders)}
        </div>
      )}

      {modalOpen && (
        <OrderModal
          order={editingOrder}
          onClose={() => { setModalOpen(false); setEditingOrder(null); }}
        />
      )}
    </div>
  );
};

export default OrdersPage;